import Vue from "vue"
import Vuex from "vuex"
import vuexPersistedstate from 'vuex-persistedstate'
import axios from 'axios'
import urlMapper from './assets/js/urlMapper.js'

Vue.use(Vuex);

const state = {
    name: "",
    id: "",
    isOneThingScene: false,
    verify: false,  // 必要条件是否符合
    showOnlineBtn: false,  // 是否有网上办理按钮
    writeNote: "",
    department: "",
    type: null,
    firstQaList: [],
    secondQaList: [],
    sceneType: "",
    hasNeedCondition: false,    // 是否有必要条件
    recommend: [],        // 关联事项，政策，服务
    approvalResult: []    // 审批结果
};

const mutations = {
    changeMatterGuideAttrs (state, param) {
        Object.keys(param).forEach(key => {
            state[key] = param[key];
        });
    }
};

const actions = {
    /**
     * [请求事项引导必要条件]
     *
     * @return  {[type]}  [Promise]
     */
    loadFirstMatterGuide ({commit}, param) {
        return new Promise((resolve, reject) => {
            axios.get(urlMapper.questions, {
            // axios.get("http://www.mocky.io/v2/5e9414283100002c005e2d7e", {
                params: {data: JSON.stringify({sceneQuestion: param})}
            }).then(res => {
                if (res.data.sceneQuestions) {
                    resolve(res.data.sceneQuestions);
                } else {
                    reject(null);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
};

export default new Vuex.Store({
	state,
	mutations,
    actions,
	plugins: [vuexPersistedstate({
		storage: window.sessionStorage
	})]
});


// WEBPACK FOOTER //
// ./yp/store.js